import { render, staticRenderFns } from "./aboutIdea.vue?vue&type=template&id=561d6b93&scoped=true"
import script from "./aboutIdea.vue?vue&type=script&lang=js"
export * from "./aboutIdea.vue?vue&type=script&lang=js"
import style0 from "./aboutIdea.vue?vue&type=style&index=0&id=561d6b93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d6b93",
  null
  
)

export default component.exports